"use client"

import { useEffect } from "react"
import {
  CONSENT_EVENT,
  getStoredConsent,
  type ConsentPreferences,
} from "@modules/cookies"

const SCRIPT_ID = "merchantWidgetScript"
const SCRIPT_SRC = "https://www.gstatic.com/shopping/merchant/merchantwidget.js"

/**
 * Google Customer Reviews — Store Widget (badge flotante).
 *
 * Sólo carga el script cuando el usuario consintió la categoría "marketing"
 * en el banner de cookies. Sin consentimiento, el badge no se muestra
 * (Google sólo enseña el widget si tu tienda tiene rating, así que tampoco
 * habría nada que renderizar — pero el script de tracking seguiría
 * ejecutándose si lo cargamos, por eso lo gateamos).
 */
export default function GoogleMerchantWidget() {
  useEffect(() => {
    let mounted = true

    const start = () => {
      const w = window as unknown as {
        merchantwidget?: { start: (cfg?: Record<string, unknown>) => void }
      }
      w.merchantwidget?.start({})
    }

    const apply = (prefs: ConsentPreferences) => {
      if (!mounted || !prefs.marketing) {
        return
      }
      if (document.getElementById(SCRIPT_ID)) {
        return
      }
      const s = document.createElement("script")
      s.id = SCRIPT_ID
      s.src = SCRIPT_SRC
      s.defer = true
      s.addEventListener("load", start)
      document.body.appendChild(s)
    }

    apply(getStoredConsent())

    const onConsentChange = (e: Event) => {
      apply((e as CustomEvent<ConsentPreferences>).detail)
    }
    window.addEventListener(CONSENT_EVENT, onConsentChange)
    return () => {
      mounted = false
      window.removeEventListener(CONSENT_EVENT, onConsentChange)
    }
  }, [])

  return null
}
